module.exports = __webpack_public_path__ + "media/images/icons/question-icon-c44a30267859c1f072c74b9a67a5db32.svg";